/* Publish by EComposer at 2025-07-28 07:47:43*/
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-uffkddvfk5r"]=  window.__ectimmers["ecom-uffkddvfk5r"] || {};
if(!this.$el)return;const e=this.$el,i=e.querySelector(".ecom-text_view-more-btn"),t=e.querySelector(".ecom-text_view-less-btn"),o=e.querySelector(".text-content.ecom-html");!o||(i&&i.addEventListener("click",()=>{o.classList.remove("ecom-text--is-mark"),o.style.maxHeight="",i.style.display="none",t.style.display=""}),t&&t.addEventListener("click",()=>{o.classList.add("ecom-text--is-mark"),o.style.maxHeight="var(--ecom-text-height)",t.style.display="none",i.style.display=""}))

                    });
                    
                        document.querySelectorAll('.ecom-uffkddvfk5r').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-uffkddvfk5r', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-i95b4tgxbxi').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-i95b4tgxbxi', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-epltutv3vxg').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-epltutv3vxg', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-z3mfki09k9').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-z3mfki09k9', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-omyg12wjsyf').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-omyg12wjsyf', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-wdg0t1dscs8').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-wdg0t1dscs8', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-risbyx5r31').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-risbyx5r31', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-u2ztt13e2gn').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-u2ztt13e2gn', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-k77r970m2ln').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-k77r970m2ln', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-w5mc5r58uu').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-w5mc5r58uu', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-flcvs58fwmj').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-flcvs58fwmj', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-6saox149teg').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-6saox149teg', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-y4tx7o5cdfs').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-y4tx7o5cdfs', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-c6573d4n5ar').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-c6573d4n5ar', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-na0e2znntvq').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-na0e2znntvq', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-rzeczxrduk').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-rzeczxrduk', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-0i3xw0v6zc77').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-0i3xw0v6zc77', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-rvsm6ozr9j').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-rvsm6ozr9j', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-im0xrnphcjs').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-im0xrnphcjs', settings: {},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-1xg84p3oavw"]=  window.__ectimmers["ecom-1xg84p3oavw"] || {};
const e=this.$el;if(!e||!this.isLive)return;const i=e.querySelector(".element__featured--wrapper-list");if(i){let t={top:0,left:0,x:0,y:0};const o=function(a){const r=a.clientX-t.x;i.scrollLeft=t.left-r},n=function(){i.removeEventListener("mousemove",o),i.removeEventListener("mouseup",n),i.style.cursor="default",i.style.removeProperty("user-select")},s=function(a){i.style.cursor="grabbing",i.style.userSelect="none",t={left:i.scrollLeft,top:i.scrollTop,x:a.clientX,y:a.clientY},i.addEventListener("mousemove",o),i.addEventListener("mouseup",n)};i.addEventListener("mousedown",s),i.addEventListener("mouseleave",n)}

                    });
                    
                        document.querySelectorAll('.ecom-1xg84p3oavw').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-1xg84p3oavw', settings: {},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-nlpmxf4u1ik"]=  window.__ectimmers["ecom-nlpmxf4u1ik"] || {};
if(!this.$el)return!1;const e=this.$el;this.settings.animation&&function(t){if(!e)return;const o=e.querySelector(".ecom__element--button");if(!o)return;let n=parseInt(t.settings.animation_loop_time)*1e3||6e3,s=1e3;window.__ectimmers["ecom-nlpmxf4u1ik"]["curdv0n3p"] = setInterval(function(){o.classList.add("animated"),setTimeout(function(){o.classList.remove("animated")},s)},n)}(this);var i=e.querySelector(".ecom__element--button");this.isLive&&i&&i.dataset.ecTrackingId&&i.addEventListener("click",function(t){if(window.Shopify.analytics){t.preventDefault();let o=document.createElement("div");document.body.appendChild(o),o.click();let n=window.EComposer.PAGE||window.EComposer.TEMPLATE||window.EComposer.SECTION||window.EComposer.BLOCK||{};const s=Object.assign({button_id:i.id,tracking_id:i.dataset.ecTrackingId},n);Shopify.analytics.publish("ec_custom_events",s),i.cloneNode(!0).click()}},{once:!0}),this.isLive&&i&&i.dataset.eventTrackingFb&&i.addEventListener("click",function(t){window.fbq&&window.fbq("track",`${i.dataset.eventTrackingFb}`)},{once:!0})

                    });
                    
                        document.querySelectorAll('.ecom-nlpmxf4u1ik').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-nlpmxf4u1ik', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-t4sxaztjyf').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-t4sxaztjyf', settings: {},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-0n53ap3qdi18"]=  window.__ectimmers["ecom-0n53ap3qdi18"] || {};
if(this.settings.link==="lightbox"&&this.settings.lightbox==="yes"&&window.EComModal&&this.$el){var e=this.$el.querySelector("[ecom-modal]");new window.EComModal(e,{cssClass:["ecom-container-lightbox-"+this.id]})}let i=this.$el;if(!i)return;function t(n){const s=n.getBoundingClientRect();return s.top>=0&&s.left>=0&&s.bottom-n.offsetHeight/2<=(window.innerHeight||document.documentElement.clientHeight)&&s.right<=(window.innerWidth||document.documentElement.clientWidth)}function o(){let n=i.querySelector(".ecom-element.ecom-base-image"),s=i.closest(".core__row--columns");n&&(t(n)?(n.classList.add("image-highlight"),s.setAttribute("style","z-index: unset")):(n.classList.remove("image-highlight"),s.setAttribute("style","z-index: 1")))}this.settings.highligh_on_viewport&&window.addEventListener("scroll",function(){o()})

                    });
                    
                        document.querySelectorAll('.ecom-0n53ap3qdi18').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-0n53ap3qdi18', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-fpf5ibfqiee').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-fpf5ibfqiee', settings: {"link":"custom","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ffwo09z8etp').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ffwo09z8etp', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-51ljort47vv').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-51ljort47vv', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-27r3051nczy').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-27r3051nczy', settings: {"link":"custom","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-k2s1snubakd').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-k2s1snubakd', settings: {"link":"custom","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    

                })();
            
;try{
 
} catch(error){console.error(error);}